import { Group } from '../types/Group';

export const tourSteps: any[] = [
  {
    target: '#userMenu',
    content: 'Click on your name to select from one of your organizations.',
    filter: (groups: Group[]): boolean => groups.length > 1,
  },
];
